// BRANDS 초성 스크롤 이벤트 수정
if (typeof smb !== 'undefined') {
  smb.scrollTo = (element) => {
    const viewportOffset = element.getBoundingClientRect();
    const top = viewportOffset.top + window.scrollY;
    const header = document.querySelector('header');
    const headerHeight = header ? header.offsetHeight : 0;

    // PC/Mobile 분기처리
    if (window.innerWidth >= 1024) {
      // PC에서 추가로 조정할 값이 있으면 설정
      const pcAdditionalOffset = 0; // 필요에 따라 값을 설정
      window.scroll({
        behavior: 'smooth',
        left: 0,
        top: top - headerHeight - pcAdditionalOffset,
      });
    } else {
      // 모바일에서 추가로 조정할 값이 있으면 설정
      const mobileAdditionalOffset = 0; // 필요에 따라 값을 설정
      window.scroll({
        behavior: 'smooth',
        left: 0,
        top: top - headerHeight - mobileAdditionalOffset,
      });
    }
  };
}
